// ABOUTME: Point-tag content resolver (SPEC-26 D8) — curated tag_copy first, humanized raw-spec fallback.
// ABOUTME: No React, no DOM: one pure strategy function, swappable without touching any consumer.

import { mergeSpecs } from '../attributeMatcher';

const humanizeKey = (key) => String(key).replace(/_/g, ' ');

/**
 * Strategy interface: (attributeKey, product) -> { label, value } | null
 *
 * Primary path: curated `product.tag_copy[attributeKey]` — a pre-written brand-voice sentence
 * lifted from the tenant's unstructured brand-knowledge docs. No label; the sentence stands alone.
 * `tag_copy` has no live source yet (SPEC-26 §0b) so this path is currently unreachable in
 * production — it stays here as the swap surface for whenever curated copy gets a real home.
 *
 * Fallback path: humanized raw `specifications` / `technical_specs` value (AC-11) — always
 * reachable, so a point-tag is never blocked on curation being complete for a given key. Uses the
 * same `specifications`-wins merge as the matcher, so a key present in both maps is never
 * triggered by one value and rendered with a different one.
 */
export function resolveTagContent(attributeKey, product) {
  const curated = product?.tag_copy?.[attributeKey];
  if (curated) return { label: null, value: curated };

  const raw = mergeSpecs(product)[attributeKey];
  if (raw == null) return null; // preserves falsy-but-valid values (0, false, '')
  // Catalogue fields can be arrays (multi-valued attributes). String() would comma-jam those
  // into one unreadable run with no spaces — exactly the mangled plate reported 2026-08-18 —
  // so lists are joined once here, and every layout shows them readably.
  const value = Array.isArray(raw) ? raw.join(', ') : String(raw);
  return { label: humanizeKey(attributeKey), value };
}
